import { FC } from 'react';
import { Col, Row, Tag, Typography } from 'antd';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { MiddleDot } from '@/shared';
import { ButtonSkeleton } from '@/shared/components/skeletons';
import { dayjs, formatStripeMoney } from '@/utilities';

interface SummaryProps {
    isFree: boolean;
    isEnterprise?: boolean;
    total: number;
    nextBillDate: any;
    interval: string;
}

const Summary: FC<SummaryProps> = ({ total, interval, nextBillDate, isFree, isEnterprise }): JSX.Element => {
    const { token } = useAntDesignTheme();

    if (isFree || isEnterprise) {
        return (
            <Row justify='space-between' align='middle' style={{ marginTop: '1rem' }}>
                <Col>
                    <Typography.Text type='secondary'>
                        {isEnterprise
                            ? 'Account-Managed Billing'
                            : interval === 'year'
                              ? 'Billed Annually'
                              : 'Billed Monthly'}
                    </Typography.Text>
                    <Typography.Title level={2} style={{ margin: 0, fontWeight: 400 }}>
                        {isEnterprise ? 'Enterprise' : 'Free'}
                    </Typography.Title>
                </Col>
            </Row>
        );
    }

    return (
        <>
            <Typography.Title level={5}>Summary</Typography.Title>
            <Row justify='space-between' align='middle' style={{ marginTop: '1rem' }}>
                <Col>
                    {total ? (
                        <>
                            <div style={{ marginBottom: '0.25rem' }}>
                                <Typography.Text type='secondary'>
                                    {interval === 'year' ? 'Billed Annually' : 'Billed Monthly'}
                                </Typography.Text>
                            </div>
                            <Typography.Title level={2} style={{ margin: 0, fontWeight: 400 }}>
                                {formatStripeMoney(total)}
                            </Typography.Title>
                        </>
                    ) : (
                        <>
                            <div style={{ marginBottom: '0.5rem' }}>
                                <ButtonSkeleton active size='small' style={{ width: 16 * 4 }} />
                            </div>
                            <div>
                                <ButtonSkeleton active size='default' style={{ width: 16 * 16 }} />
                            </div>
                        </>
                    )}
                </Col>
                {nextBillDate ? (
                    <Col>
                        <Tag style={{ marginRight: 0 }}>
                            <span style={{ color: token.colorTextSecondary }}>Next Invoice</span>
                            <MiddleDot horizontalMargin={'0.5rem'} />
                            {dayjs(nextBillDate * 1000).format('LL')}
                        </Tag>
                    </Col>
                ) : (
                    <>
                        <div>
                            <ButtonSkeleton active size='small' style={{ width: 16 * 8 }} />
                        </div>
                    </>
                )}
            </Row>
        </>
    );
};

export default Summary;
